module.exports = __webpack_public_path__ + "static/media/monthly-prize.06ba0444.svg";